import { ActivationBanner } from "../../components/ActivationBanner"
import { SettingsNavLinks } from "../../components/SettingsNavLinks"
import { Card } from "../../components"
import { SubAndEmailPage } from "../../components/SubAndEmailPage"

export const View = () =>{
    return(
        <>
            <SettingsNavLinks
            navtitle="Settings"
            navtitlelink="Subscription and emails"
            />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business
             profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
            />
            <Card>
                <div className ='sub-email-section-header'>
                    <strong>Prevent failed payments</strong>
                         <p>Configure whether you’d like to email customers 
                         to keep their payment information up to date</p>
                    </div>
                    <div className="border-bottom">
                    <SubAndEmailPage
                    rightcontent="Customer emails"
                    leftcontent="Send emails about upcoming renewals"
                    />
                    <SubAndEmailPage
                    rightcontent=""
                    leftcontent="Send emails about expiring cards"
                    />
                    </div >
                    <div className ='sub-email-section-header'>
                    <strong>Manage failed payments</strong>
                         <p>Configure whether you’d like to email customers to keep 
                            their payment information up to date</p>
                    </div>
                    <div className="border-bottom">
                    <SubAndEmailPage
                    rightcontent="Retry schedule"
                    leftcontent="Retry immediately"
                    />
                    <SubAndEmailPage
                    rightcontent=""
                    leftcontent="Retry 2 days after the previous attempt"
                    />
                     <SubAndEmailPage
                    rightcontent=""
                    leftcontent="Retry 4 days after the previous attempt"
                    />
                     <SubAndEmailPage
                    rightcontent=""
                    leftcontent="Retry 6 days after the previous attempt"
                    />
                    </div>
                    <div className="border-bottom">
                    <SubAndEmailPage
                    rightcontent="Customer emails"
                    leftcontent="Notify customers on failed card payment methods or gateways"
                    />
                    <SubAndEmailPage
                    rightcontent="Subscription"
                    leftcontent="if all retries for a payment fails,notify customer on subscription cancelation"
                    />
                    </div>
                    <div className ='sub-email-section-header'>
                    <strong>Manage invoices sent to customers</strong>
                         <p>Configure whether you’d like to email customers to keep 
                            their payment information up to date</p>
                    </div>
                    <div className="border-bottom">
                    <SubAndEmailPage
                    rightcontent="Customer emails"
                    leftcontent="Emal finalized invoices to customers"
                    />
                    <SubAndEmailPage
                    rightcontent=""
                    leftcontent="Send reminders if a recurring invoice hasn't been paid"
                    />
                    </div >
                    <div className="border-bottom">
                    <SubAndEmailPage
                    rightcontent="Subscription"
                    leftcontent="Resend expired invoices 2 days after previous attempt"
                    />
                    </div>
                    <div className="border-bottom">
                    <SubAndEmailPage
                    rightcontent="Invoice status"
                    leftcontent="Resend expired invoices 2 days after previous attempt"
                    />
                    </div>
            </Card>
        </>
    )
}